export const TWITTER_DOMAIN = 'https://platform.twitter.com';
export const TWITTER_STATIC_URL = 'https://static.ads-twitter.com';
export const TWITTER_CO_URL = 'https://t.co';
export const TWITTER_ANALYTICS_URL = 'https://analytics.twitter.com';
